


































import Group from '@/types/Group.interface'
import GroupQueryConstructor from '@/components/GroupQueryConstructor.vue'
import Vue, { PropType } from 'vue'
export default Vue.extend({
    components: { GroupQueryConstructor },
    props: {
        //  The group being edited
        group: {
            type: Object as PropType<Group>,
            required: true
        },
        //  Disable the 'save' button
        loading: {
            type: Boolean,
            default: false
        },
        //  The maxium horizontal width of the form
        maxWidth: {
            type: String,
            default: '400px'
        }
    },
    data() {
        return {
            //  Determines whether or not we can save our group
            disabled: false,
            //  A clone of the original group, used for editing
            temp: null
        }
    },
    mounted() {
        //  Remove persons_ids, which are not used in query groups, so we can pass api validation
        delete this.group['persons_ids']

        //  Clone the original group, so we can revert changes if needed
        this.temp = window._.cloneDeep(this.group)
    },
    methods: {
        //  Reset the form (ie set 'temp' and 'queryBuilder' to default state)
        clearForm(): void {
            //  Reset temp
            this.temp = null

            //  reset query builder
            this.$refs.queryBuilder.clearQuery()
        },
        //  Handles the 'queryValidated' event from queryBuilder.  Sets the 'disabled' state of the form
        onQueryValidated(val: boolean): void {
            this.disabled = !val
        },
        //  Handles the 'querySelected' event from queryBuilder.  Updates the 'temp.query'
        onQuerySelected(query: object): void {
            //  Check if the inputed query is already loaded
            const equal = window._.isEqual(this.temp.query, query)

            //  If the selected query is not equal to the group's query, update the group
            if (!equal) this.temp.query = query
        },
        //  Validates and Submits 'temp' to the parent hosting the form
        async submit(): Promise<void> {
            //  Validate the form
            const isValid = await this.$validator.validate()

            //  If the form is NOT valid, return
            if (!isValid) return

            //  Emit form to parent
            this.$emit('submit', this.temp)
        }
    }
})
